import React from "react";
import { Link } from "react-router-dom";

/**
 * LEP Logo — rombo/diamante con línea dorada, iniciales LEP,
 * texto "LOGÍSTICA EJECUTIVA" y "PREMIUM" con líneas decorativas.
 */
export const Logo = ({ size = "md", to = "/", className = "" }) => {
  const sizes = {
    sm: { diamond: 34, initials: "text-[10px]", top: "text-[8px]", bottom: "text-[7px]", gap: "gap-2" },
    md: { diamond: 46, initials: "text-xs", top: "text-[10px]", bottom: "text-[9px]", gap: "gap-3" },
    lg: { diamond: 68, initials: "text-base", top: "text-sm", bottom: "text-xs", gap: "gap-4" },
    xl: { diamond: 96, initials: "text-2xl", top: "text-lg", bottom: "text-base", gap: "gap-5" },
  };
  const s = sizes[size];

  const inner = (
    <div className={`flex items-center ${s.gap} ${className}`} data-testid="lep-logo">
      {/* Diamond */}
      <div
        className="relative flex items-center justify-center"
        style={{ width: s.diamond, height: s.diamond }}
      >
        <div
          className="absolute inset-0 rotate-45 border border-[#C9A227]"
          style={{ borderRadius: 4 }}
        />
        <div
          className="absolute inset-[3px] rotate-45 border border-[#C9A227]/30"
          style={{ borderRadius: 3 }}
        />
        <span
          className={`relative font-display font-bold text-[#F5F5F5] tracking-widest ${s.initials}`}
        >
          LEP
        </span>
      </div>

      {/* Word mark */}
      <div className="flex flex-col leading-tight">
        <span className={`font-display font-bold text-[#F5F5F5] uppercase tracking-brand ${s.top}`}>
          Logística Ejecutiva
        </span>
        <span className="flex items-center gap-2 mt-0.5">
          <span className="h-px w-4 bg-[#C9A227]" />
          <span className={`font-display font-semibold text-[#C9A227] uppercase tracking-executive ${s.bottom}`}>
            Premium
          </span>
          <span className="h-px w-4 bg-[#C9A227]" />
        </span>
      </div>
    </div>
  );

  return to ? <Link to={to} data-testid="lep-logo-link">{inner}</Link> : inner;
};

export default Logo;
